import React from 'react';
import PropTypes from 'prop-types';

import '../css/team-signings.css';

class TeamSignings extends React.Component {
  static propTypes = {
    signings: PropTypes.array,
  }
  
  formatName = (name) => {
    return name.replace(/\s/g, '')
      .replace(/-/g, '')
      .replace(/'/g, '')
      .replace(/\./g, '')
      .replace(/’/g, '')
      .toLowerCase();
  }

  render() {
    return (
      <div id="team-signings" className='benton-regular'>
        <h6 className='benton-bold'>2021 Patriots signings</h6>
        <table>
          <tbody>
            <tr><th>Name</th><th>Pos.</th><th>Details</th></tr>
            {this.props.signings.map((value) => (
            <tr className="signing" key={`signings-${this.formatName(value.name)}`}>
              <td>{value.name}</td>
              <td>{value.position}</td>
              <td>{value.deal}, <a className="benton-regular" href={value.story} target="_blank" rel="noreferrer">More coverage</a></td>
            </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}


export default TeamSignings;